import React from 'react';
import { Panel, Typography, Div } from '@icecreamsocial/components';
import { AuthorizeNetLogo } from '../../../../../presentational';

const AuthorizeNetDescription = () => {
	return (
		<Panel marginBottom="md" backgroundColor="bodyInverse">
			<Panel.Body display="flex" alignItems="center" style={{ gap: '16px' }}>
				<AuthorizeNetLogo />
				<Div flex="1 0">
					<Typography.H4
						display="block"
						typoSize="lg"
						typoWeight="400"
						marginTop="0"
						marginBottom="md"
					>
						authorize.net
					</Typography.H4>
					<Typography.Span display="block">
						Reward influencers through order refund credit
					</Typography.Span>
				</Div>
			</Panel.Body>
		</Panel>
	);
};

AuthorizeNetDescription.displayName = 'AuthorizeNetDescription';

export default AuthorizeNetDescription;
